export const recursivelyConvertStrings = (
    node: string | SimpleChildElementModel | Array<string | SimpleChildElementModel>,
    onStringFound: (arg: string) => string | SimpleChildElementModel
): string | SimpleChildElementModel | SimpleChildElementModel[] | null => {
    if (typeof node === 'string') {
        return onStringFound(node) as string;
    }

    if (Array.isArray(node)) {
        return node.map((arrNode) =>
            recursivelyConvertStrings(arrNode, onStringFound)
        ) as SimpleChildElementModel[];
    }

    if (typeof node.props.children === 'string') {
        return {
            ...node,
            props: {
                ...node.props,
                children: onStringFound(node.props.children) as string,
            },
        };
    }

    if (Array.isArray(node.props.children)) {
        return {
            ...node,
            props: {
                ...node.props,
                children: node.props.children.map((child) =>
                    recursivelyConvertStrings(child, onStringFound)
                ) as SimpleChildElementModel[],
            },
        };
    }

    // in this case, the node is already converted to <Phone /> or <Hours /> component... just pass it through
    return node;
};
